import { mergeWith } from 'lodash-es';

export const mergeData = (data: AnyObject, newData: AnyObject) =>
    mergeWith({}, data, newData, (objValue, srcValue) => {
        if (Array.isArray(objValue) || Array.isArray(srcValue)) {
            return srcValue;
        }
    });
